import Text from '@sats-group/ui-lib/react/text';
import VisuallyButton from '@sats-group/ui-lib/react/visually-button';
import React from 'react';
import type { Shortcuts as Props } from './shortcuts.types';

export const Shortcuts: React.FC<Props> = ({ elementName, entries, label }) =>
  React.createElement(
    elementName,
    {
      'aria-label': label,
      className: 'shortcuts',
    },
    entries.map(entry => (
      <a className="shortcuts__entry" href={entry.href} key={entry.href}>
        <Text theme={entry.emphasized ? Text.themes.emphasis : undefined}>
          {entry.text}
        </Text>
        <div>
          <VisuallyButton
            elementName="div"
            iconOnly
            leadingIcon={
              <div dangerouslySetInnerHTML={{ __html: entry.rawIcon }} />
            }
            size={VisuallyButton.sizes.small}
            text={entry.text}
            variant={VisuallyButton.variants.primaryWhite}
          />
        </div>
      </a>
    ))
  );
